<template>
  <div v-bind:class="['store__item', store.placeholder ? 'placeholder' : '']">
    <div v-if="!store.placeholder" class="store__name" v-html="store.name"></div>
    <h5 v-if="store.meta && !store.placeholder" class="store__meta" v-html="store.meta"></h5>
    <ul v-if="!store.placeholder" class="store__address">
      <li class="hour__title">Location</li>
      <li
        v-for="(address, storeIndex) in store.details"
        v-bind:key="`store-${store.value}-${storeIndex}`"
        v-html="removeSpecialChars(address)"
      ></li>
    </ul>
    <ul v-if="store.hours && !store.placeholder && !store.closed" class="store__hours">
      <li class="hour__title">Store Hours</li>
      <li
        v-for="(tradingHr, hrIndex) in store.hours"
        v-bind:key="`storeHr-${store.value}-${hrIndex}`"
        v-html="tradingHr"
      ></li>
      <li v-if="store.clickcollect" class="hour__closed"><em>Click and Collect Only</em></li>
    </ul>
    <ul v-if="store.closed" class="store__hours">
      <li class="hour__title">Store Hours</li>
      <li class="hour__closed"><em>Temporarily closed</em></li>
      <li v-if="store.clickcollect" class="hour__closed"><em>Click and Collect Only</em></li>
    </ul>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'StoreItem',
  props: {
    store: Object,
  },
  methods: {
    removeSpecialChars(str) {
      return str.replace(/\s+/g, ' ')
        .replace(/^(\s*)([\W\w]*)(\b\s*$)/g, '$2');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "@/assets/scss/settings.scss";

$store-gap: $spacing;
$store-name-size: $body-font-size;
$store-title-size: $body-font-size;
$store-details-size: $body-font-size;
$store-details-line-height: $body-line-height;

// Custom styles
.store__name {
  margin-bottom: $spacing-half;
  font-size: $store-name-size;
  font-weight: 700;

  .store__list & {
    @include medium-up {
      width: calc(31% - #{$spacing});
      margin-bottom: 0;
    }
  }
}

.store__address,
.store__hours {
  padding: 0;
  margin: 0;
  list-style: none;
  font-size: $store-details-size;
  line-height: $store-details-line-height;
  font-weight: normal;

  .store__list & {
    @include medium-up {
      width: calc(31% - #{$spacing});
      margin: 0 0 0 $spacing;
    }
  }
}

.store__hours {
  margin-top: $spacing-half;

  .store__list & {
    @include medium-up {
      margin-top: 0;
    }
  }
}

.hour__title {
  margin-bottom: ($spacing-half / 2);
  font-size: $store-title-size;
  line-height: $store-details-line-height;
  font-weight: 500;
}

.hour__closed {
  color: $grey-light;
}

.store__list {
  .store__item {
    width: 100%;
    margin-bottom: $spacing * 1.5;

    // @include small-up {
    //   width: calc(50% - #{$spacing-half});
    // }

    @include medium-up {
      // width: calc(33% - #{$spacing-half});
      display: flex;
      margin-bottom: $spacing-double;
      justify-content: space-between;
      flex-wrap: nowrap;
    }

    &:after {
      content: '';
      flex: auto;
    }
  }

  .placeholder {
    margin: 0;
  }
}

.store__meta {
  margin: round($store-name-size / 2) 0;
}
</style>
